<template>
  <v-container fluid id="about-me"
               class="section-height d-flex align-center soft-grey title font-weight-light text-center px-5"
  >
    <v-row style="max-width: 720px;" class="mx-auto" no-gutters>
      <v-col cols="12">
        Здравствуйте!
      </v-col>
      <v-col cols="12">
        Меня зовут Мария, я клинический психолог, психотерапевт. Консультирую взрослых (от 18 лет) очно в Москве и Онлайн. Помогаю изменить свою жизнь в предпочитаемом направлении.
      </v-col>
      <v-col cols="12">
        В своей работе я интегрирую методы разных подходов, среди которых: телесно-ориентированная, процессуальная терапия, психосинтез, схема-терапия.
      </v-col>
      <v-col cols="12">
        Закончила психологический факультет МГУ в 2019г., регулярно прохожу повышения квалификации, супервизию и личную терапию.
      </v-col>
      <v-col cols="12">
        Для меня близка идея о том, что «грамм контакта заменяет тонну техник», поэтому для изменений важнее не техники и упражнения, а терапевтические отношения.
      </v-col>
      <v-col cols="12">
        В связи с этим я уделяю много внимания созданию безопасной и доверительной атмосферы, где можно быть принятым, понятым, увиденным в своей индивидуальности.
      </v-col>
      <v-col cols="12">
        <v-avatar
          class="elevation-12 mb-12"
          size="128"
        >
          <v-img src="@/images/cover.jpg"></v-img>
        </v-avatar>
      </v-col>
      <v-col cols="12">
        <router-link to="/sign_up">
          <v-btn
            color="grey"
            outlined
            large
          >
          <span class="grey--text text--darken-1 font-weight-bold">
            Консультация
          </span>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
name: "AboutMe"
}
</script>

<style scoped>

</style>
